import React from 'react';
import { FontAwesomeIcon as Fa } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import PaginationComponent from 'react-reactstrap-pagination';

const Loading = (props) => {
	const { e, config } = props;
	return (
		!e ? (
			<div {...config} className="text-center">
				<Fa icon={faSpinner} className="fa-spin fa-3x" />
			</div>
		) : 'error'
	);
};

const Pagination = (props) => (
	<PaginationComponent
		firstPageText="«"
		previousPageText="‹"
		nextPageText="›"
		lastPageText="»"
		{...props}
	/>
);

export {
	Loading,
	Pagination,
};
